import { initializeDB } from '../config/db';
import { SRD_INSPECTION_STORE } from '../config/constants';
import axiosInstance from '../axiosInstance';

const srdInspectionService = {
    async submit(inspection) {
        try {
            const response = await axiosInstance.post('/srd-inspection/submit', inspection);
            return response.data;
        } catch (error) {
            console.error('Error submitting SRD inspection:', error);
            throw error;
        }
    },

    async saveDraft(inspection) {
        const db = await initializeDB();
        const now = new Date().toISOString();

        const toSave = {
            ...inspection,
            updatedAt: now,
        };

        if (!toSave.status) {
            toSave.status = 'draft';
        }

        if (!toSave.createdAt) {
            toSave.createdAt = now;
        }

        await db.put(SRD_INSPECTION_STORE, toSave);
        return toSave;
    },

    async loadByUuid(uuid) {
        const db = await initializeDB();
        return await db.get(SRD_INSPECTION_STORE, uuid);
    },

    async getAll() {
        const db = await initializeDB();
        return await db.getAll(SRD_INSPECTION_STORE);
    },

    async delete(uuid) {
        const db = await initializeDB();
        await db.delete(SRD_INSPECTION_STORE, uuid);
    }
};

export default srdInspectionService;
